var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"app-background-color footer"},[_c('span',{staticClass:"caption accent--text px-4"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+", Сервис проведения мероприятий ")])])}
var staticRenderFns = []

export { render, staticRenderFns }